import axios from 'axios';
const storyblokService = process.server ? require('../server/services/storyblokService') : null;

export const state = () => ({
  story: null,
});

export const mutations = {
  setPageStory(state, story) {
    state.story = story;
  },
};

export const actions = {
  async getPageStory({ rootState, commit }, { path }) {
    const { version, language, cv } = rootState;

    try {
      let data = {};

      if (process.server) {
        data = await storyblokService.getStory(path, { version, language, cv });
      } else {
        const resp = await axios.get('/api/stories', {
          params: { path, version, language, cv }
        });
        data = resp.data;
      }

      const { story } = data;

      commit('setPageStory', story);

      return story;
    } catch(err) {
      throw err;
    }
  },
};
